import { render } from "./SeparatorTabletFormComponent.vue?vue&type=template&id=4004fb90"
import script from "./SeparatorTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./SeparatorTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__